module.exports = __webpack_public_path__ + "img/red-packet-success.39d758a6.png";